import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./App.css";

import AppRoutes from "./routes/AppRoutes";
import GlobalToaster from "./components/GlobalToaster";

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      offset: 100,
      once: true,
      mirror: false,
      easing: "ease-in-out",
    });
  }, []);
  return (
    <>
      <AppRoutes />
      <GlobalToaster />
    </>
  );
};

export default App;
